import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { glassPrice } from "../MaterialsSlice";

// Models
export interface price {
    id: number,
    glass_id: number,
    glass_work_id: number,
    price: string,
}

// Add material state
export interface editMaterialPricingState {
    prices: price[],
    glassPrice?: glassPrice,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialEditMaterialPricingState: editMaterialPricingState = {
    prices: [{ glass_id: 0, glass_work_id: 0, id: 0, price: "0" }],
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Users slice
export const editMaterialPricingSlice = createSlice({
    name: 'edit_material_pricing',
    initialState: initialEditMaterialPricingState,
    reducers: {
        init: state => initialEditMaterialPricingState,
        set: (state, { payload }: PayloadAction<price>) => {
            state.prices = [payload]
        },
        setPriceValue: (state, { payload }: PayloadAction<string>) => {
            state.prices[0].price = payload;
            if (state.glassPrice != null) {
                state.glassPrice.price = parseInt(payload);
            }
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsSuccess: (state, { payload }: PayloadAction<boolean>) => {
            state.isSuccess = payload
        },
        setIsOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.isOpen = payload
        },
        setGlassPrice: (state, { payload }: PayloadAction<glassPrice>) => {
         
            state.glassPrice = payload
        },
    }
})